import { useFetch } from "@/helpers/composables/useFetch";
import { route } from "ziggy-js";
import NProgress from "nprogress";


interface returnItem {
    list_item_id: number;
    quantity: number;
    variation: Object;
    price: string;
}

export function useReturnOrder (
    returnData: Array<returnItem>
 ) {

    const getReturnCost = (returnData, { afterFetch }) => {

        const { data } = useFetch(route("endpoint.return.amount"), {
            beforeFetch: (ctx) => {
                NProgress.start();
                ctx.options.headers = {
                    ...ctx.options.headers,
                    'Accept': 'application/json',
                }
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
            }
        })
            .post(returnData)
            .json();
        return data;
    };

    return {
        getReturnCost
    };
}
